<app-base-card>
  <app-geofence-details-header [id]="id()" />
  <div class="geofence-selectors">
    <p-selectbutton
      optionLabel="label"
      optionValue="value"
      [allowEmpty]="false"
      [ngModel]="selectedGeofenceId()"
      [options]="geofenceOptions()"
      (ngModelChange)="onSelectGeofence($event)"
    >
      <ng-template let-option pTemplate="item">
        <span class="indicator" [class]="[GeofenceKind[option.kind]]"></span>
        <span>{{ option.label }}</span>
      </ng-template>
    </p-selectbutton>
  </div>
  <div class="map-help">
    <small>
      Click a geofence on the map to select it, then drag its points to adjust the shape. Drag a midpoint to add a new
      point, or right-click a point to remove it. Save and Discard buttons will appear below the map when you have
      unsaved changes.
    </small>
  </div>
  @let latLng = hubLatLng();
  @if (latLng) {
    <app-google-maps-polygon-editor
      [enableDrawing]="false"
      [initialCenter]="latLng"
      [geofences]="slimGeofences()"
      [selectedGeofence]="selectedGeofence()"
      [restrictToHubBounds]="false"
      (geofenceCoordinatesChange)="onGeofenceCoordinatesChange($event)"
      (selectedGeofenceChange)="this.selectedGeofence.set($event)"
    ></app-google-maps-polygon-editor>
  }
  @if (hasChanges()) {
    <div class="form-actions">
      <p-button label="Discard" [text]="true" [disabled]="saving()" (onClick)="onDiscard()"></p-button>
      <p-button label="Save Changes" [loading]="saving()" (onClick)="onSave()"></p-button>
    </div>
  }
</app-base-card>

@if (selectedGeofence()?.geofenceKind === GeofenceKind.Delivery) {
  <app-base-card>
    <div class="table-container">
      <app-delivery-windows-header [id]="selectedGeofence()!.geofenceId" />
      <app-delivery-windows-table [id]="selectedGeofence()!.geofenceId" />
    </div>
  </app-base-card>
}
